import { render, staticRenderFns } from "./Myworks.vue?vue&type=template&id=be39a216&"
import script from "./Myworks.vue?vue&type=script&lang=js&"
export * from "./Myworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports